import { z } from "zod";

export const getOrganizationPartnershipsQuerySchema = z.object({
	state: z
		.preprocess(
			(val) => (val === undefined ? undefined : Array.isArray(val) ? val : [val]),
			z.array(z.enum(["active", "inactive", "pending"])).optional(),
		)
		.optional(),
	as: z.enum(["host", "partner", "both"]).optional(),
});

export type GetOrganizationPartnershipsQuerySchema = z.infer<
	typeof getOrganizationPartnershipsQuerySchema
>;
